import CrmContactFieldsHelper from "./fields";
import FieldsCollection from "../../fields3/collection/base/fields-collection";
import FormManager from "../../gd-form/common/form-manager";
import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {Feature} from "../../gd/access-control/feature-access/const";
import {SettingsParentSection} from "../../../app/settings/const";

const TITLE_FIELD_MIN_WIDTH = 300

const debug = false
export default class CrmContactModule extends ModuleProto {

    constructor(moduleConfig: any) {
        super(ModuleType.CRM_CONTACT, moduleConfig);

        this.name                       = "CRM Contact"
        this.description                = "The GoodDay CRM Contacts Module centralizes all contact information, streamlining communication and interaction management with your clients and leads. It offers advanced customization options for contact fields, ensuring that every piece of data from contact details to interaction history is organized according to your business needs. This module enhances your ability to maintain comprehensive, up-to-date records, facilitating better relationship management and targeted communication strategies. \n\n This module requires the GoodDay CRM module to be enabled first."
        this.svgIcon                    = "isvg-crm-contact"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "CRM"
        this.settingsUrl                = "settings/crm-contact"
        this.parentSection              = SettingsParentSection.CRM

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

        this.feature                    = Feature.CRM
        this.validateFeature()
    }

    get enabled() {
        return super.enabled && gd.modules.crm.enabled
    }

    // deprecated use fields in models2
    static getFieldsCollection() {
        const config = CrmContactFieldsHelper.getFieldsConfig();
        return new FieldsCollection(config);
    }

    static getSystemFieldsCollection() {
        const config = CrmContactFieldsHelper.getSystemFieldsConfig();
        return new FieldsCollection(config);
    }

    static getCustomFieldsCollection() {
        const config = CrmContactFieldsHelper.getCustomFieldsConfig();
        return new FieldsCollection(config);
    }

    static saveCustomFields(fieldsCollection: FieldsCollection) {
        return CrmContactFieldsHelper.saveCustomFields(fieldsCollection);
    }

    // NE ISPOLZUETSYA, getFormFieldsConfig() NE SOZDAN

    // static getFormFieldsCollection() {
    //     const config = CrmContactFields.getFormFieldsConfig();
    //     return new FieldsCollection(config);
    // }

    static getGlistConfig() {
        const titleField = 'name'

        const glistConfig = _.get(gd.company.settings.modules, 'crmContact.glist');

        let columns = _.get(glistConfig,'columns',null) || [
            {fieldId: 'name'},
            {fieldId: 'phone'},
            {fieldId: 'email'},
            // {fieldId: 'contactType'},
            {fieldId: 'crmAccountId'},
        ];

        const titleFieldColumn = _.find(columns, column => column.fieldId === titleField)
        if(!titleFieldColumn) {
            columns.unshift({fieldId: titleField, minWidth: TITLE_FIELD_MIN_WIDTH})
        } else {
            titleFieldColumn.minWidth = TITLE_FIELD_MIN_WIDTH
        }

        const groupByValue = glistConfig && glistConfig.groupBy ? glistConfig.groupBy : {
            fieldId     : 'contactType',
            direction   : "asc"
        };

        return {columns, groupByValue, titleField}
    }

    static saveGlistConfig(columns:any, groupByValue: any) {
        const company = gd.session.companies.get(gd.companyId);
        company.settings.modules.crmContact.glist.columns = columns;
        company.settings.modules.crmContact.glist.groupBy = groupByValue;
        company.settings.save()
    }

    // config for new contact form
    static getFormConfig(options: any = {}) {
        const fields = CrmContactModule.getFieldsCollection();

        const initFormData: any = {};
        const formStructureFields: any = {};

        const hideFields = ['contactOwnerUserId'];

        _.map(fields.all(), field=>{
            initFormData[field.fieldId] = options.initValues && options.initValues[field.fieldId] ? options.initValues[field.fieldId] : field.formInitValue;
            formStructureFields[field.fieldId] = {
                type:       field.formType,
                isRequired: field.isRequired,
                label:      field.label,
                validator:  field.validator.bind(field),
            }
        })

        const formStructure = {
            fields: formStructureFields,
            onSubmit: options.onSubmit,
            isFormChanged: true,
        };

        // hide some specified fields and not required customFields
        const allFields = fields.all().slice();
        _.map(allFields, field=>{
            if (hideFields.includes(field.fieldId) || (field.isCustom && !field.isRequired)) {
                fields.removeById(field.fieldId);
            }
        })

        return {
            formManager: new FormManager(formStructure, initFormData),
            formFields: fields
        };
    }

    toJson() {
        debug && console.log(debug, "toJson() type=",this.type, "_isEnabled=", this._isEnabled)

        const result = super.toJson();
        // const result = {}

        debug && console.log(debug, "    newConfig=", result)

        return result
    }
}
